//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import SignUp from '@/components/ui/landing/signup/SignUp';
import TermsAndPolicy from '@/components/ui/landing/signup/TermsAndPolicy.vue';
import Celebration from '@/components/ui/landing/signup/Celebration.vue';
export default {
	components: {
		SignUp,
		TermsAndPolicy,
		Celebration,
	},
	layout: 'auth',
	// async fetch() {
	// 	console.log('공통코드패치 한다.... ??');
	// 	try {
	// 		await this.$store.dispatch('code/getAllCodes', '');
	// 	} catch (error) {}
	// },
	computed: {
		...mapGetters('auth', ['isTermsAgree', 'isPolicyAgree', 'isConfirmAgree', 'isRegistrated']),
		displayTermsAndPolicy() {
			return this.isConfirmAgree === false && this.isRegistrated === false;
		},
		displaySignUp() {
			return this.isConfirmAgree === true && this.isRegistrated === false;
		},
	},
	async mounted() {
		console.log('공통코드패치 한다.... ??');
		try {
			await this.$store.dispatch('code/getAllCodes', '');
		} catch (error) {}
		this.$store.commit('auth/SET_TERMS_AGREE', false);
		this.$store.commit('auth/SET_POLICY_AGREE', false);
		this.$store.commit('auth/SET_CONFIRM_AGREE', false);
		this.$store.commit('auth/SET_IS_REGISTRATED', false);
	},
};
